<div class="gita-page">
  <div class="header-section">
    <h1 class="title"><b>Gita Missionaria</b><br />Napoli</h1>
    <p class="subtitle">19-22 Marzo 2026</p>
    <p class="info">Iscrizioni aperte fino al 12 febbraio</p>
  </div>

  <!-- Programma -->
  <div class="content-section">
    <div class="program-card">
      <h2>Programma del Viaggio</h2>

      <div class="timeline">
        <div class="timeline-item">
          <div class="timeline-marker">
            <span class="day-number">GIO</span>
            <span class="day-date">19</span>
          </div>
          <div class="timeline-content">
            <h3>Partenza</h3>
            <div class="event">
              <span class="event-time">22:00</span>
              <span class="event-desc">Partenza in pullman</span>
            </div>
          </div>
        </div>

        <div class="timeline-item">
          <div class="timeline-marker">
            <span class="day-number">VEN</span>
            <span class="day-date">20</span>
          </div>
          <div class="timeline-content">
            <h3>Napoli</h3>
            <div class="event">
              <span class="event-time">Mattina</span>
              <span class="event-desc"
                >Visita turistica della città di Napoli</span
              >
            </div>
            <div class="event">
              <span class="event-time">Pomeriggio</span>
              <span class="event-desc"
                >Culto e cena presso centro missionario "Missionary
                Revival"</span
              >
              <span class="event-location"
                >Via Dominiziana 561, Castel Volturno (CE)</span
              >
            </div>
          </div>
        </div>

        <div class="timeline-item">
          <div class="timeline-marker">
            <span class="day-number">SAB</span>
            <span class="day-date">21</span>
          </div>
          <div class="timeline-content">
            <h3>Giugliano</h3>
            <div class="event">
              <span class="event-time">Tutto il giorno</span>
              <span class="event-desc">"Send Me Day"</span>
              <span class="event-location"
                >Via Casacelle 115, Giugliano (NA)</span
              >
            </div>
          </div>
        </div>

        <div class="timeline-item">
          <div class="timeline-marker">
            <span class="day-number">DOM</span>
            <span class="day-date">22</span>
          </div>
          <div class="timeline-content">
            <h3>Culto e Raduno</h3>
            <div class="event">
              <span class="event-time">10:30</span>
              <span class="event-desc"
                >Culto mattutino - Chiesa di Giugliano</span
              >
            </div>
            <div class="event">
              <span class="event-time">18:00</span>
              <span class="event-desc"
                >Raduno regionale "Come Tralci Campania"</span
              >
            </div>
            <div class="event">
              <span class="event-time">22:00</span>
              <span class="event-desc">Partenza per il rientro</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Cosa Portare -->
  <div class="content-section">
    <div class="packing-card">
      <h2>Cosa Portare</h2>
      <p class="packing-intro">
        L'alloggio sarà presso il centro missionario "Missionary Revival" di
        Castel Volturno.<br />
        Ricorda di portare:
      </p>
      <div class="packing-list">
        <span class="packing-item">Lenzuola</span>
        <span class="packing-item">Plaid</span>
        <span class="packing-item">Asciugamani</span>
      </div>
      <p class="packing-note">
        I pasti sono inclusi dalla cena di venerdì alla cena di domenica.<br />
        <strong>Cena di giovedì e pranzo di venerdì sono al sacco.</strong>
      </p>
    </div>
  </div>

  <!-- Form Iscrizione -->
  <div class="registration-section">
    <div class="title">
      <h2>Modulo di Iscrizione</h2>
      <p class="form-info">
        Compila tutti i campi richiesti per iscriverti alla gita
      </p>
    </div>

    @if (isSuccess) {
      <div class="success-container">
        <div class="success-icon">&#10004;</div>
        <h3>Iscrizione Completata!</h3>
        <p>{{ successMessage }}</p>
        <div class="payment-reminder">
          <h4>Prossimi passi:</h4>
          <ol>
            @if (tipoTrasporto === "solo-pasti") {
              <li>
                Consegna l'importo di
                <strong>{{ formatPrice(calcolaPrezzoTotale) }}</strong> al
                referente Flavio D.
              </li>
            } @else {
              <li>
                Consegna l'acconto di
                <strong>{{ formatPrice(calcolaAcconto) }}</strong> al referente
                Flavio D. entro il 12 febbraio
              </li>
              <li>Completa il pagamento secondo le scadenze indicate</li>
              <li>
                Prepara il necessario per l'alloggio (lenzuola, plaid,
                asciugamani)
              </li>
            }
          </ol>
        </div>
        <button
          type="button"
          class="new-registration-btn"
          (click)="resetForm()"
        >
          Nuova Iscrizione
        </button>
      </div>
    } @else {
      <form class="registration-form" (ngSubmit)="onSubmit()">
        <!-- Dati Anagrafici -->
        <div class="section-title">Dati Anagrafici</div>

        <div class="form-row">
          <div class="form-group">
            <label for="nome">Nome *</label>
            <input
              type="text"
              id="nome"
              name="nome"
              [(ngModel)]="nome"
              placeholder="Il tuo nome"
              required
            />
          </div>
          <div class="form-group">
            <label for="cognome">Cognome *</label>
            <input
              type="text"
              id="cognome"
              name="cognome"
              [(ngModel)]="cognome"
              placeholder="Il tuo cognome"
              required
            />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="telefono">Cellulare *</label>
            <input
              type="tel"
              id="telefono"
              name="telefono"
              [(ngModel)]="telefono"
              placeholder="+39 123 456 7890"
              required
            />
          </div>
          <div class="form-group">
            <label for="dataNascita">Data di nascita *</label>
            <input
              type="date"
              id="dataNascita"
              name="dataNascita"
              [(ngModel)]="dataNascita"
              required
            />
          </div>
        </div>

        <!-- Sezione Minorenne (appare solo se minorenne) -->
        @if (isMinorenne) {
          <div class="section-title">Accompagnamento minore</div>

          <div class="minorenne-details">
            <!-- Tipo accompagnamento -->
            <div class="form-group">
              <label>Come partecipi? *</label>
              <div class="accompagnamento-options">
                <label
                  class="accompagnamento-option"
                  [class.selected]="tipoAccompagnamento === 'accompagnato'"
                >
                  <input
                    type="radio"
                    name="tipoAccompagnamento"
                    value="accompagnato"
                    [(ngModel)]="tipoAccompagnamento"
                  />
                  <div class="option-content">
                    <span class="option-title">Accompagnato</span>
                    <span class="option-desc"
                      >Partecipo con un genitore/tutore</span
                    >
                  </div>
                </label>
                <label
                  class="accompagnamento-option"
                  [class.selected]="tipoAccompagnamento === 'non-accompagnato'"
                >
                  <input
                    type="radio"
                    name="tipoAccompagnamento"
                    value="non-accompagnato"
                    [(ngModel)]="tipoAccompagnamento"
                  />
                  <div class="option-content">
                    <span class="option-title">Non accompagnato</span>
                    <span class="option-desc"
                      >Partecipo con delega firmata</span
                    >
                  </div>
                </label>
              </div>
            </div>

            <!-- Campi per accompagnato -->
            @if (tipoAccompagnamento === "accompagnato") {
              <div class="form-row">
                <div class="form-group">
                  <label for="nomeGenitore"
                    >Nome genitore/accompagnatore *</label
                  >
                  <input
                    type="text"
                    id="nomeGenitore"
                    name="nomeGenitore"
                    [(ngModel)]="nomeGenitore"
                    placeholder="Nome del genitore"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="cognomeGenitore"
                    >Cognome genitore/accompagnatore *</label
                  >
                  <input
                    type="text"
                    id="cognomeGenitore"
                    name="cognomeGenitore"
                    [(ngModel)]="cognomeGenitore"
                    placeholder="Cognome del genitore"
                    required
                  />
                </div>
              </div>
            }

            <!-- Campi per non accompagnato -->
            @if (tipoAccompagnamento === "non-accompagnato") {
              <div class="delega-section">
                <div class="delega-info">
                  <p>
                    Per consentire la partecipazione del minore senza
                    accompagnatore, e necessario caricare una delega firmata da
                    un genitore o tutore legale.
                  </p>
                  <p><strong>La delega deve contenere:</strong></p>
                  <ul>
                    <li>Nome e cognome del genitore/tutore</li>
                    <li>Nome e cognome del minore</li>
                    <li>Data e luogo di nascita del minore</li>
                    <li>
                      Dichiarazione di autorizzazione alla partecipazione senza
                      accompagnatore
                    </li>
                    <li>Data e firma del genitore/tutore</li>
                  </ul>
                  <p class="format-note">
                    Formato accettato: PDF oppure foto leggibile del documento
                    firmato (JPG / PNG)
                  </p>
                </div>

                <div class="form-group">
                  <label for="delega">Carica delega firmata *</label>
                  <div class="file-upload-container">
                    <input
                      type="file"
                      id="delega"
                      name="delega"
                      (change)="onFileSelected($event)"
                      accept=".pdf,.jpg,.jpeg,.png"
                      #fileInput
                    />
                    <div
                      class="file-upload-area"
                      (click)="fileInput.click()"
                      [class.has-file]="delegaFile"
                    >
                      @if (delegaFile) {
                        <div class="file-selected">
                          <span class="file-icon"
                            ><img
                              src="https://www.svgrepo.com/show/447635/file-signed.svg"
                              width="30"
                              height="30"
                          /></span>
                          <span class="file-name">{{ delegaFile.name }}</span>
                          <button
                            type="button"
                            class="remove-file"
                            (click)="removeFile($event)"
                          >
                            &times;
                          </button>
                        </div>
                      } @else {
                        <div class="upload-placeholder">
                          <span class="upload-icon"
                            ><img
                              width="30"
                              height="30"
                              src="https://www.svgrepo.com/show/513861/upload.svg"
                          /></span>
                          <span>Clicca per caricare o trascina il file</span>
                          <span class="upload-formats"
                            >PDF, JPG, PNG (max 10MB)</span
                          >
                        </div>
                      }
                    </div>
                  </div>
                  @if (fileError) {
                    <div class="file-error">{{ fileError }}</div>
                  }
                </div>
              </div>
            }
          </div>
        }

        <!-- Quota Partecipazione -->
        <div class="section-title">Quota di Partecipazione</div>

        <div class="form-group">
          <div class="cost-options">
            <label
              class="cost-option"
              [class.selected]="tipoTrasporto === 'pullman'"
            >
              <input
                type="radio"
                name="tipoTrasporto"
                value="pullman"
                [(ngModel)]="tipoTrasporto"
              />
              <h3>Con Pullman</h3>
              <div class="price-main">
                {{
                  isBambino
                    ? formatPrice(PREZZO_PULLMAN_BAMBINO)
                    : formatPrice(PREZZO_PULLMAN_ADULTO)
                }}
                <span class="price-note"
                  >(Bambini fino a 10 anni:
                  {{ formatPrice(PREZZO_PULLMAN_BAMBINO) }})</span
                >
              </div>
            </label>

            <label
              class="cost-option"
              [class.selected]="tipoTrasporto === 'mezzi-propri'"
            >
              <input
                type="radio"
                name="tipoTrasporto"
                value="mezzi-propri"
                [(ngModel)]="tipoTrasporto"
              />
              <h3>Mezzi Propri</h3>
              <div class="price-main">
                {{
                  isBambino
                    ? formatPrice(PREZZO_MEZZI_PROPRI_BAMBINO)
                    : formatPrice(PREZZO_MEZZI_PROPRI_ADULTO)
                }}
                <span class="price-note"
                  >(Bambini:
                  {{ formatPrice(PREZZO_MEZZI_PROPRI_BAMBINO) }})</span
                >
              </div>
              <p class="price-description">Solo alloggio e pasti</p>
            </label>

            <label
              class="cost-option"
              [class.selected]="tipoTrasporto === 'solo-pasti'"
            >
              <input
                type="radio"
                name="tipoTrasporto"
                value="solo-pasti"
                [(ngModel)]="tipoTrasporto"
              />
              <h3>Solo Pasti</h3>
              <div class="price-main">
                {{
                  isBambino
                    ? formatPrice(PREZZO_SOLO_PASTI_BAMBINO)
                    : formatPrice(PREZZO_SOLO_PASTI_ADULTO)
                }}
                <span class="price-note"
                  >(Bambini: {{ formatPrice(PREZZO_SOLO_PASTI_BAMBINO) }})</span
                >
              </div>
              <p class="price-description">
                Solo i pasti, senza alloggio e trasporto
              </p>
            </label>
          </div>

          <div class="payment-info-box">
            <strong
              >Acconti consegnati a mano al referente dell’iniziativa, Flavio
              D.</strong
            ><br />
            Pagamento solo in contanti
          </div>
        </div>

        <!-- Note aggiuntive -->
        <div class="section-title">Informazioni Aggiuntive</div>

        <div class="form-group">
          <label for="note">Note (allergie, intolleranze, ecc.)</label>
          <textarea
            id="note"
            name="note"
            [(ngModel)]="note"
            placeholder="Indica eventuali intolleranze alimentari, allergie o altre informazioni utili"
            rows="3"
          ></textarea>
        </div>

        <!-- Privacy -->
        <div class="section-title">Privacy</div>

        <div class="form-group privacy-section">
          <p class="privacy-text">
            I dati saranno trattati da Come Tralci per gestire l'iscrizione e
            l'organizzazione della gita, adempiere obblighi di legge e gestire
            comunicazioni operative.
            <a href="javascript:void(0)" (click)="openPrivacyDialog()"
              >Informativa completa</a
            >.
          </p>
          <label class="privacy-checkbox">
            <input
              type="checkbox"
              name="accettazionePrivacy"
              [(ngModel)]="accettazionePrivacy"
            />
            Dichiaro di aver preso visione dell'informativa
          </label>
        </div>

        <!-- Riepilogo Prezzo -->
        @if (tipoTrasporto) {
          <div class="price-summary">
            <div class="section-title">Riepilogo</div>
            <div class="price-row">
              <span>
                @if (tipoTrasporto === "pullman") {
                  Quota con pullman
                } @else if (tipoTrasporto === "mezzi-propri") {
                  Quota mezzi propri
                } @else {
                  Quota solo pasti
                }
                {{ isBambino ? "(bambino)" : "" }}</span
              >
              <span>{{ formatPrice(calcolaPrezzoTotale) }}</span>
            </div>
            <div class="payment-schedule">
              <p class="schedule-title">Suddivisione pagamenti:</p>
              @if (tipoTrasporto === "pullman") {
                <div class="schedule-row">
                  <span>Acconto iscrizione (entro 12/2)</span><span>60 €</span>
                </div>
                <div class="schedule-row">
                  <span>Seconda rata (entro 6/3)</span><span>60 €</span>
                </div>
                <div class="schedule-row">
                  <span>Saldo alla partenza</span
                  ><span>{{ isBambino ? "20" : "50" }} €</span>
                </div>
              } @else if (tipoTrasporto === "solo-pasti") {
                <div class="schedule-row">
                  <span>Pagamento unico</span
                  ><span>{{ formatPrice(calcolaPrezzoTotale) }}</span>
                </div>
              } @else {
                <div class="schedule-row">
                  <span>Acconto iscrizione (entro 12/2)</span><span>20 €</span>
                </div>
                <div class="schedule-row">
                  <span>Saldo alla partenza</span
                  ><span>{{ isBambino ? "15" : "50" }} €</span>
                </div>
              }
            </div>
            <div class="price-total">
              <span>Totale da versare</span>
              <span>{{ formatPrice(calcolaPrezzoTotale) }}</span>
            </div>
          </div>
        }

        <button
          type="submit"
          class="submit-btn"
          [disabled]="!isFormValid() || isSubmitting"
        >
          @if (isSubmitting) {
            INVIO IN CORSO...
          } @else {
            CONFERMA ISCRIZIONE
          }
        </button>

        @if (errorMessage) {
          <div class="message error-message">
            {{ errorMessage }}
          </div>
        }
      </form>
    }
  </div>

  <!-- Privacy Dialog -->
  @if (showPrivacyDialog) {
    <div class="privacy-dialog-overlay" (click)="closePrivacyDialog()">
      <div class="privacy-dialog" (click)="$event.stopPropagation()">
        <div class="privacy-dialog-header">
          <h3>Informativa Privacy</h3>
          <button
            type="button"
            class="privacy-dialog-close"
            (click)="closePrivacyDialog()"
          >
            &times;
          </button>
        </div>
        <div class="privacy-dialog-content">
          <section class="privacy-policy">
            <h1>Informativa Privacy ex artt. 13 e 14 GDPR</h1>

            <p>
              Caro/a partecipante e, in caso di partecipante minorenne, caro
              genitore/tutore (o soggetto delegato), ai sensi degli artt. 13 e
              14 del Regolamento (UE) 2016/679 in materia di protezione dei dati
              personali (“GDPR”) ti informiamo di quanto segue.
            </p>

            <p>
              In caso di iscrizione di un minorenne, i dati del minore sono
              conferiti dal genitore/tutore (o delegato) che procede
              all’iscrizione; la presente informativa è resa al genitore/tutore
              anche nell’interesse del minore.
            </p>

            <h2>1. Titolare del trattamento</h2>
            <p>
              Il Titolare del trattamento è l’<strong
                >Associazione Chiese Cristiane Evangeliche Pentecostali e
                Missionarie Come Tralci</strong
              >
              (o, in forma abbreviata, “Come Tralci” o “C.T.C.”), con sede in
              Borgo San Giovanni (LO), via Enrico Fermi snc., CAP 26851, in
              persona del legale rappresentante pro tempore
              <strong>Gennaro Chiocca</strong>.
            </p>
            <p>
              Contatti:
              <strong
                ><a href="mailto:segreteria&#64;cometralci.com"
                  >segreteria&#64;cometralci.com</a
                ></strong
              >
            </p>

            <h2>2. Tipologie di dati trattati</h2>
            <ul>
              <li>
                <strong>Dati comuni identificativi e di contatto:</strong>
                nome, cognome, numero di cellulare ed eventuale indirizzo e-mail
                (se richiesto dal form).
              </li>
              <li>
                <strong>Dati di pagamento e amministrativi:</strong>
                dati necessari alla gestione del pagamento (es. esito della
                transazione, identificativi dell’operazione) ed eventuali dati
                necessari per adempimenti contabili e fiscali, ove applicabili.
              </li>
              <li>
                <strong>Partecipanti minorenni:</strong>
                dati identificativi del genitore/tutore (o del soggetto
                legittimato all’iscrizione) ed eventuale copia o estremi del
                documento di identità, esclusivamente per finalità di verifica
                della legittimazione e gestione di affidamento/deleghe.
              </li>
            </ul>

            <h2>3. Finalità del trattamento e base giuridica</h2>

            <h3>a) Gestione dell’iscrizione e organizzazione dell’evento</h3>
            <p>
              <strong>Finalità:</strong> registrazione dell’iscrizione,
              organizzazione della partecipazione e della logistica, invio di
              comunicazioni operative (conferme, orari, punto di ritrovo,
              variazioni), gestione di rinunce o rimborsi.
            </p>
            <p>
              <strong>Base giuridica:</strong> art. 6, par. 1, lett. b) GDPR.
            </p>
            <p>
              <strong>Conferimento:</strong> necessario; il rifiuto impedisce
              l’iscrizione o la corretta organizzazione della partecipazione.
            </p>

            <h3>b) Gestione del pagamento e adempimenti amministrativi</h3>
            <p>
              <strong>Finalità:</strong> gestione degli incassi, tracciamento
              delle transazioni, emissione di ricevute o fatture, adempimenti
              contabili e fiscali.
            </p>
            <p>
              <strong>Base giuridica:</strong> art. 6, par. 1, lett. b) e/o
              lett. c) GDPR.
            </p>
            <p>
              <strong>Conferimento:</strong> necessario; il rifiuto impedisce il
              perfezionamento dell’iscrizione o l’adempimento degli obblighi di
              legge.
            </p>

            <h3>c) Partecipanti minorenni</h3>
            <p>
              <strong>Finalità:</strong> verifica della legittimazione del
              genitore/tutore, corretta gestione dell’affidamento e delle
              eventuali deleghe, prevenzione di iscrizioni non autorizzate.
            </p>
            <p>
              <strong>Base giuridica:</strong> art. 6, par. 1, lett. f) GDPR
              (legittimo interesse).
            </p>
            <p>
              <strong>Conferimento:</strong> necessario se richiesto; la mancata
              comunicazione può impedire l’accettazione dell’iscrizione del
              minore.
            </p>

            <h2>4. Modalità del trattamento</h2>
            <p>
              Il trattamento è effettuato con strumenti elettronici e/o
              cartacei, nel rispetto dei principi di liceità, correttezza,
              trasparenza e minimizzazione dei dati, adottando misure di
              sicurezza tecniche e organizzative adeguate.
            </p>
            <p>
              Non sono effettuati processi decisionali automatizzati né attività
              di profilazione ai sensi dell’art. 22 GDPR.
            </p>

            <h2>5. Destinatari dei dati</h2>
            <ul>
              <li>Personale e collaboratori autorizzati dal Titolare;</li>
              <li>
                Responsabili esterni del trattamento (art. 28 GDPR) per servizi
                tecnici e organizzativi;
              </li>
              <li>Istituti bancari e provider di pagamento;</li>
              <li>Consulenti amministrativi, contabili e legali;</li>
              <li>Autorità pubbliche, ove previsto dalla legge.</li>
            </ul>

            <h2>6. Trasferimenti verso Paesi terzi</h2>
            <p>
              Eventuali trasferimenti di dati fuori dallo Spazio Economico
              Europeo avverranno nel rispetto degli artt. 44–49 GDPR, sulla base
              di decisioni di adeguatezza o garanzie adeguate (es. Clausole
              Contrattuali Standard).
            </p>

            <h2>7. Periodo di conservazione</h2>
            <ul>
              <li>
                Dati identificativi e di partecipazione:
                <strong>6 mesi</strong> dalla conclusione dell’evento;
              </li>
              <li>
                Dati amministrativi e contabili: secondo i termini di legge
                (fino a <strong>10 anni</strong>);
              </li>
              <li>
                Documento di identità del genitore/tutore: non oltre
                <strong>30 giorni</strong> dalla conclusione dell’evento.
              </li>
            </ul>

            <h2>8. Diritti degli interessati</h2>
            <p>
              È possibile esercitare i diritti previsti dagli artt. 15–22 GDPR
              (accesso, rettifica, cancellazione, limitazione, portabilità,
              opposizione) contattando il Titolare ai recapiti indicati.
            </p>

            <h2>9. Obbligatorietà del conferimento</h2>
            <p>
              Il conferimento dei dati è necessario per la gestione
              dell’iscrizione e della partecipazione all’evento. In caso di
              minori, i dati del genitore/tutore sono indispensabili per la
              verifica della legittimazione.
            </p>

            <h2>10. Diritto di reclamo</h2>
            <p>
              È possibile proporre reclamo al
              <strong>Garante per la protezione dei dati personali</strong>
              ai sensi dell’art. 77 GDPR qualora si ritenga che il trattamento
              violi la normativa vigente.
            </p>
          </section>
        </div>
        <div class="privacy-dialog-footer">
          <button
            type="button"
            class="privacy-dialog-btn confirm"
            (click)="closePrivacyDialog()"
          >
            CHIUDI
          </button>
        </div>
      </div>
    </div>
  }
</div>
